import { Serializable } from '../../core/models/serializable';
export class Locality implements Serializable<Locality> {
  fromObject(obj: any): Locality {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    let result = {
      LocalityId: this.localityId,
      CountryId: this.countryId,
      Name: this.name,
      IsCity: this.isCity,
      IsCapital: this.isCapital,
    };
    return result;
  }

  public localityId: number;

  public countryId: number;

  public name: string;

  public isCity: boolean;

  public isCapital: boolean;
}
